import { AnyAction } from 'redux';
import { ActionTypes, IClusterState } from './types/state.types';

const initialState: IClusterState = {
  list: [],
};

const vmReducer = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: IClusterState = initialState,
  { type, payload }: AnyAction,
): IClusterState => {
  switch (type) {
    case ActionTypes.SET_LIST:
      return { ...state, list: payload };
    default:
      return state;
  }
};

export default vmReducer;
